import { initDelegatedPasswordToggles } from '../../modules/password-toggle.js';

const alertCloseButtons = document.querySelectorAll<HTMLButtonElement>('.login-alert-close');
const loginForm = document.getElementById('loginForm') as HTMLFormElement | null;
const emailInput = document.getElementById('email') as HTMLInputElement | null;
const rememberCheckbox = document.getElementById('lembrar') as HTMLInputElement | null;

const feedbackParams = ['logout', 'sessao_expirada'];
const rememberPreferenceSuppressedKey = 'nfse-login-remember-suppressed';

function clearFeedbackParams(): void {
  const url = new URL(window.location.href);
  let changed = false;

  feedbackParams.forEach((param) => {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      changed = true;
    }
  });

  if (!changed) {
    return;
  }

  const nextUrl = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, document.title, nextUrl);
}

clearFeedbackParams();

function suppressRememberedLogin(): void {
  window.sessionStorage.setItem(rememberPreferenceSuppressedKey, '1');

  if (rememberCheckbox) {
    rememberCheckbox.checked = false;
  }

  if (emailInput) {
    emailInput.value = '';
  }
}

function clearRememberedLoginPreference(): void {
  void fetch('login.php', {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: new URLSearchParams({
      action: 'clear_remembered_login',
    }),
    credentials: 'same-origin',
  }).catch(() => {
    // A supressão local já evita repopular no refresh da aba atual.
  });
}

if (window.sessionStorage.getItem(rememberPreferenceSuppressedKey) === '1') {
  suppressRememberedLogin();
}

alertCloseButtons.forEach((button) => {
  button.addEventListener('click', () => {
    const alert = button.closest<HTMLElement>('.login-alert');

    if (alert) {
      alert.style.display = 'none';
    }
  });
});

initDelegatedPasswordToggles();

if (rememberCheckbox) {
  rememberCheckbox.addEventListener('change', () => {
    if (rememberCheckbox.checked) {
      window.sessionStorage.removeItem(rememberPreferenceSuppressedKey);
      return;
    }

    suppressRememberedLogin();
    clearRememberedLoginPreference();
  });
}

if (loginForm) {
  loginForm.addEventListener('submit', () => {
    if (rememberCheckbox?.checked) {
      window.sessionStorage.removeItem(rememberPreferenceSuppressedKey);
      return;
    }

    window.sessionStorage.setItem(rememberPreferenceSuppressedKey, '1');
  });
}
